import { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import { useLocation, NavLink } from 'react-router-dom';

import Menu from '../components/Menu';
import InfiniteScroll from 'react-infinite-scroll-component'

/* import components */

import ListGroup from 'react-bootstrap/ListGroup'
import ChevronRight from '../components/icons/ChevronRight'

import articlesApi from '../api/articlesApi'
import { PER_PAGE } from '../components/variables/variables';

const SectionArticleList = (props) => {
   const { state } = useLocation()
   const { tripId, sectionId } = useParams()
   const [articles, setArticles] = useState([])
   const [currPage, setCurrPage] = useState(1)
   const [loading, setLoading] = useState(true);
   const [hasMore, setHasMore] = useState(true)

   const getArticlesBySectionIdAndServiceType = async (page = 1) => {
     try {
       setLoading(true)
       const response = await articlesApi.getArticlesByServiceType({
         perPage: PER_PAGE,
         page: currPage,
         serviceType: state.serviceType,
         status: state.status,
         tripId: tripId,
         sectionId: sectionId,
       })

       if (response?.status) {
         setArticles([...articles, ...response.data.data])
         setCurrPage(page + 1)
         setHasMore(response.data.data.length >= PER_PAGE)
       }
     } catch (err) {
       console.error(err)
     } finally {
       setLoading(false)
     }
   }

   useEffect(() =>{
       getArticlesBySectionIdAndServiceType()
     }, [])

  return (
    <>
      <Menu title={state.topic.name} />
      <ListGroup variant='flush' style={{ paddingTop: '10px' }}>
        <InfiniteScroll
          dataLength={currPage * PER_PAGE}
          next={() => getArticlesBySectionIdAndServiceType(currPage)}
          hasMore={hasMore}
          loader={<h6>Loading...</h6>}
        >
          {articles?.map((article) => (
            <NavLink
              to={article?.sectionId < 0 ? article.insuranceUrl : `/trip/${tripId}/topic/${article.id}`}
              style={{ textDecoration: 'none' }}
              key={article.id}
              state={{
                topic: article,
              }}
            >
              <ListGroup variant='flush'>
                <ListGroup.Item
                  variant='flush'
                  className='topicOptions alignTextDiffSize grey'
                  style={{
                    fontFamily: 'Open Sans Semi-Bold',
                  }}
                >
                  <div
                    style={{
                      marginTop: 'auto',
                      marginBottom: 'auto',
                      paddingRight: '15px',
                    }}
                  >
                    {article.name}
                  </div>
                  <div style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                    <ChevronRight size='12' fill='#D8D8D8' />
                  </div>
                </ListGroup.Item>
                <ListGroup.Item style={{ padding: '1px' }} />
              </ListGroup>
            </NavLink>
          ))}
        </InfiniteScroll>
      </ListGroup>
      </>
  )
}

export default SectionArticleList
